import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 4l8 3v15l-8 -3l0 -15","key":"svg-0"}],["path",{"d":"M13 19h6v-15h-14","key":"svg-1"}]]

/**
 * IconDualScreen
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZHVhbC1zY3JlZW4iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgNGw4IDN2MTVsLTggLTNsMCAtMTUiIC8+CiAgPHBhdGggZD0iTTEzIDE5aDZ2LTE1aC0xNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/dual-screen
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconDualScreen = createReactComponent('outline', 'dual-screen', 'DualScreen', __iconNode);

export default IconDualScreen;